import { render } from "./ThePageError.vue?vue&type=template&id=1cdb962a&scoped=true&ts=true"
import script from "./ThePageError.vue?vue&type=script&lang=ts"
export * from "./ThePageError.vue?vue&type=script&lang=ts"

import "./ThePageError.vue?vue&type=style&index=0&id=1cdb962a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdb962a"]])

export default __exports__